import { render, staticRenderFns } from "./FeedbackSettingsPanel.vue?vue&type=template&id=4902e626&scoped=true"
import script from "./FeedbackSettingsPanel.vue?vue&type=script&lang=js"
export * from "./FeedbackSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSettingsPanel.vue?vue&type=style&index=0&id=4902e626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902e626",
  null
  
)

export default component.exports